import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { CurrencyModel } from '../../../../../shared/store/currency/types';
import { View } from '../../../../../shared/store/view/types';
import { ActivatedRoute, Router } from '@angular/router';
import { CurrencyService } from '../../../../../shared/store/currency/currency.service';
import { SubHeaderService } from '../../../../../shared/store/subheader/subheader.service';
import { BreadcrumbService } from 'xng-breadcrumb';
import { ViewService } from '../../../../../shared/store/view/views.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter } from 'rxjs/operators';
import {
  ModalComponent,
  ModalComponentKey,
} from 'src/app/shared/service/modal-component';

@UntilDestroy()
@ModalComponent(ModalComponentKey.CurrencyDetailsContent)
@Component({
    selector: 'app-currency-details-content',
    templateUrl: './currency-details-content.component.html',
    styleUrls: ['./currency-details-content.component.scss'],
    standalone: false
})
export class CurrencyDetailsContentComponent implements OnInit, OnDestroy {
  currencyId: number;
  currencyBase$: Observable<CurrencyModel>;
  view$: Observable<View>;

  @Input() modalId: number;

  constructor(
    private route: ActivatedRoute,
    private readonly currencyService: CurrencyService,
    private readonly subHeaderService: SubHeaderService,
    private readonly router: Router,
    private readonly breadcrumbService: BreadcrumbService,
    private readonly viewService: ViewService
  ) {
    this.currencyBase$ = this.currencyService.getById.value$;
    this.view$ = this.viewService.getViews.value$;
  }

  ngOnInit(): void {
    this.currencyId = this.route.snapshot.params['id'];

    if (this.modalId) this.currencyId = this.modalId;

    this.currencyService.getById.call(this.currencyId.toString());

    this.currencyBase$
      .pipe(
        untilDestroyed(this),
        filter((x) => !!x)
      )
      .subscribe((x) => {
        this.breadcrumbService.set('@currencyDetails', x.name);
      });
    this.view$
      .pipe(
        untilDestroyed(this),
        filter((x) => !!x)
      )
      .subscribe((x) => {
        this.breadcrumbService.set('@list', x.title);
      });

    this.subHeaderService.getTriggerAction().subscribe((x) => {
      if (x == 'currencyEdit') {
        this.router.navigate([
          'Configuration/Currencies/Edit/',
          this.currencyId,
        ]);
        this.subHeaderService.setTriggerAction('');
      }
    });
  }

  ngOnDestroy(): void {
    this.currencyService.getById.reset();
    this.breadcrumbService.set('@currencyDetails', ' ');
  }
}
